export enum BaseballUnderReviewAttribute {
  CallStands = 1053,
  CallOverturned = 1054,
}
